import React, { useEffect, useState } from "react";
import { StyledHeader } from "./ClubFinancial";
import LabelText from "../../../ui/LabelText";
import DonutRingChart from "./DonutRingChart";
import { IDonutRingData, ItotalAssets, ItotalLiabilities } from "../../../types/IClubDetail";

interface ClubRevenueBreakDownProps {
  data: ItotalAssets | undefined;
  liabilitiesData: ItotalLiabilities | undefined;
}

const TotalAseetsLiabilities: React.FC<ClubRevenueBreakDownProps> = ({ data, liabilitiesData }) => {
  const [donutRingData, setDonutRingData] = useState<IDonutRingData[] | undefined>();
  const [donutLiabilitiesData, setDonutLiabilitiesData] = useState<IDonutRingData[] | undefined>();

  useEffect(() => {
    setDonutRingData([
      { color: "#00D1A8", value: data?.intangible, text: data?.intangibleText, label: "Intangible", Inferred: data?.isIntangibleInferred },
      { color: "#FF7800", value: data?.tangible, text: data?.tangibleText, label: "tangible ", Inferred: data?.isTangibleInferred },
      { color: "#FFC2C2", value: data?.financial, text: data?.financialText, label: "financial", Inferred: data?.isFinancialInferred },
      { color: "#C9F0B5", value: data?.inventory, text: data?.inventoryText, label: "inventory", Inferred: data?.isInventoryInferred },
      { color: "#64ADDB", value: data?.other, text: data?.otherText, label: "Other", Inferred: data?.isOtherInferred },
    ]);
  }, [data]);

  useEffect(() => {
    setDonutLiabilitiesData([
      {
        color: "#00D1A8",
        value: liabilitiesData?.shortTermDebt,
        text: liabilitiesData?.shortTermDebtText,
        label: "short term debt",
        Inferred: liabilitiesData?.isShortTermDebtInferred,
      },
      {
        color: "#FF7800",
        value: liabilitiesData?.longTermDebt,
        text: liabilitiesData?.longTermDebtText,
        label: "long term debt ",
        Inferred: liabilitiesData?.isLongTermDebtInferred,
      },
      {
        color: "#FFC2C2",
        value: liabilitiesData?.reservesProvisions,
        text: liabilitiesData?.reservesProvisionsText,
        label: "reserves & provisions",
        Inferred: liabilitiesData?.isReservesProvisionsInferred,
      },
      {
        color: "#C9F0B5",
        value: liabilitiesData?.retainedEarnings,
        text: liabilitiesData?.retainedEarningsText,
        label: "retained earnings",
        Inferred: liabilitiesData?.isRetainedEarningsInferred,
      },
      {
        color: "#64ADDB",
        value: liabilitiesData?.other,
        text: liabilitiesData?.otherText,
        label: "Other",
        Inferred: liabilitiesData?.isOtherInferred,
      },
    ]);
  }, [liabilitiesData]);

  return (
    <>
      <div className="flex-chart-container">
        <div className="flex-chart-container-wrapper">
          <StyledHeader className="header-content">
            <LabelText className="drawer-title">Total assets</LabelText>
          </StyledHeader>
          <DonutRingChart data={donutRingData} total={data?.totalAssetsText} type="assets" />
        </div>
        <div className="flex-chart-container-wrapper">
          <StyledHeader className="header-content">
            <LabelText className="player-family-name">Liabilities</LabelText>
          </StyledHeader>
          <DonutRingChart data={donutLiabilitiesData} total={liabilitiesData?.totalLiabilitiesText} type="liabilities" />
        </div>
      </div>
    </>
  );
};

export default TotalAseetsLiabilities;
